
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ConstellationsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.fillStyle = pc.color;
        ctx.strokeStyle = pc.color;
        
        const stars: {x: number, y: number}[] = [];
        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const px = x + this.pseudoRandom(x + layerIndex) * spacing;
                const py = y + this.pseudoRandom(y + layerIndex) * spacing;
                stars.push({x: px, y: py});
                
                ctx.beginPath();
                ctx.arc(px, py, 1.5 * (config.parallaxScale || 1.0), 0, Math.PI * 2);
                ctx.fill();
            }
        }

        // Connect nearby stars
        ctx.lineWidth = 0.5 * (config.parallaxScale || 1.0);
        const maxDistSq = (spacing * spacing * 1.5) * (config.parallaxComplexity || 1.0);
        
        const drawLines = () => {
            for (let i = 0; i < stars.length; i++) {
                for (let j = i + 1; j < stars.length; j++) {
                    const d2 = (stars[i].x - stars[j].x)**2 + (stars[i].y - stars[j].y)**2;
                    if (d2 < maxDistSq) {
                        ctx.beginPath();
                        ctx.moveTo(stars[i].x, stars[i].y);
                        ctx.lineTo(stars[j].x, stars[j].y);
                        ctx.stroke();
                    }
                }
            }
        };

        ctx.save();
        ctx.globalAlpha *= 0.3;
        drawLines();
        ctx.restore();
        
        this.applyGlow(pc, drawLines);
    }
}
